module.exports = __webpack_public_path__ + "img/b2.af99ad29.png";